import { Select, Spin } from "antd";
import React, { useState } from "react";
import Error from "../Error";
import PlusButton from "../Buttons/plus";
import { useNavigate } from "react-router-dom";
import { select_search } from "../../Controllers/Global";
import toast from "react-hot-toast";
import { Modal } from "antd";

// import ProductsForm from "../../Pages/Products/Products/Form";
import ProductunitsForm from "../../Pages/Products/Units/Form";
import ProductcategoriesForm from "../../Pages/Products/Categories/Form";
import ProductbrandsForm from "../../Pages/Products/Brands/Form";

import InventoryBatchForm from "../../Pages/Inventory/Batch/Form";
import InventoryTransferForm from "../../Pages/Inventory/Transfer/Form";
import InventoryReceivedForm from "../../Pages/Inventory/Received/Form";
import InventoryRequestForm from "../../Pages/Inventory/Request/Form";
import InventoryRequestedForm from "../../Pages/Inventory/Requested/Form";
import InventoryExpiryForm from "../../Pages/Inventory/Expiry/Form";

import BillingForm from "../../Pages/Billings/Billings/Form";
import BillingsFormSales from "../../Pages/Billings/Billings/Form/sales";
import BillingsReturnsForm from "../../Pages/Billings/Returns/Form";

import PurchasesOrderForm from "../../Pages/Purchases/Order/Form";

import ExpensesForm from "../../Pages/Expenses/Expenses/Form";
import ExpensecategoriesForm from "../../Pages/Expenses/Categories/Form";

import CustomersForm from "../../Pages/Customers/Customers/Form";
import SuppliersForm from "../../Pages/Suppliers/Suppliers/Form";

import FeatureUnlockModal from "../../Pages/FeatureLocks/Form";

import TaxForm from "../../Pages/Settings/Tax/Tax/Form";
import TaxTypeForm from "../../Pages/Settings/Tax/Tax_Types/Form";

import ImportForm from "../../Pages/Settings/Import/Form";

import UsersForm from "../../Pages/Settings/Users/Form";
import BranchesForm from "../../Pages/Settings/Branches/Form";
import RolesForm from "../../Pages/Settings/Roles/Form";

const addRouteMap = {
  // "/app/products/add": ProductsForm,
  "/app/products/units/add": ProductunitsForm,
  "/app/products/categories/add": ProductcategoriesForm,
  "/app/products/brands/add": ProductbrandsForm,

  "/app/inventory/add": InventoryBatchForm,
  "/app/inventory/transfer/add": InventoryTransferForm,
  "/app/inventory/received/add": InventoryReceivedForm,
  "/app/inventory/request/add": InventoryRequestForm,
  "/app/inventory/requested/add": InventoryRequestedForm,
  "/app/inventory/expiry/add": InventoryExpiryForm,

  "/app/billing/add": BillingForm,
  "/app/billing/new/add": BillingsFormSales,
  "/app/billing/returns/add": BillingsReturnsForm,

  "/app/purchases/add": PurchasesOrderForm,
  "/app/purchases/orders/add": PurchasesOrderForm,

  "/app/expenses/add": ExpensesForm,
  "/app/expenses/categories/add": ExpensecategoriesForm,

  "/app/customers/add": CustomersForm,

  "/app/suppliers/add": SuppliersForm,

  "/app/feature-lock/add": FeatureUnlockModal,

  "/app/settings/tax/add": TaxForm,
  "/app/settings/tax/types/add": TaxTypeForm,

  "/app/settings/users/add": UsersForm,
  "/app/settings/branches/add": BranchesForm,
  "/app/settings/roles/add": RolesForm,
};

const Selectaddcomponent = React.forwardRef((props, focus) => {
  const { index, ind, val, form, setForm, getFormdata } = props;

  const [loader, setLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [DynamicComponent, setDynamicComponent] = useState(null);

  let navigate = useNavigate();

  const handleSelect = (e, index, ind) => {
    let data = [...form];

    data[index].options[ind].form.value = e;

    if (data[index]?.options[ind]?.show?.check) {
      data?.map((value, k) => {
        value?.options?.map((val, i) => {
          if (val?.show?.name == data[index].options[ind].form.name) {
            data[k].options[i].show.status = e ? true : false;
          }
        });
      });
    }

    setForm(data);
    getFormdata(data);
  };

  const handleSearch = async (e, index, ind) => {
    setLoader(true);

    let data = [...form];
    const normalize = (str) => {
      return str
        ?.toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9\s]/g, "");
    };

    const select = !data[index].options[ind].form.api
      ? { ...data[index].options[ind].form.params }
      : {
        api: data[index].options[ind].form.api,
        search: normalize(e),
        status: 1,
      };

    const search = await select_search(select);

    if (search?.status) {
      let options = [];

      if (data[index].options[ind].form.name == "customer") {
        search?.data?.data?.map((value, index) => {
          options?.push({
            value: value?._id,
            label:
              value?.name && value?.code && value?.phone
                ? value?.code + " " + value?.name + " (" + value?.phone + ")"
                : value?.name && value?.code
                  ? value?.code + " " + value?.name
                  : value?.phone && value?.code
                    ? value?.code + " (" + value?.phone + ")"
                    : value?.name && value?.phone
                      ? value?.name + " (" + value?.phone + ")"
                      : value?.name
                        ? value?.name
                        : value?.phone
                          ? value?.phone
                          : "",
          });
        });
      } else {
        search?.data?.data?.map((value, index) => {
          options?.push({ value: value?._id, label: value?.name });
        });
      }

      data[index].options[ind].form.options = options;

      setForm(data);
      getFormdata(data);
      setLoader(false);
    } else {
      toast?.error(search?.message);
      setLoader(false);
    }
  };

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const handleOpenComponent = () => {
    const Comp = addRouteMap[val?.path];

    if (Comp) {
      setDynamicComponent(() => Comp);
      setOpen(true);
    } else {
      navigate(val?.path);
    }
  };


  return (
    <React.Fragment>
      <div className="flex w-full">
        <div className="flex-grow w-full">
          <Select
            key={index}
            id={index?.toString()?.concat(ind)}
            name={val?.form?.name}
            placeholder={val?.form?.placeholder}
            className={
              val?.form?.className
                ? val?.form?.className
                : "text-regular w-full"
            }
            ref={focus.current[val?.form?.name?.concat(index + "" + ind)]}
            size={val?.form?.size}
            mode={val?.form?.mode}
            allowClear={val?.form?.allowClear}
            showSearch={val?.form?.showSearch}
            filterOption={val?.form?.filterOption}
            // disabled={loader}
            options={val?.form?.options}
            value={val?.form?.value}
            onKeyDown={handleOnKeyDown}
            onClick={() => handleSearch("", index, ind)}
            onFocus={() => handleSearch("", index, ind)}
            onSearch={(e) => handleSearch(e, index, ind)}
            onChange={(e) => handleSelect(e, index, ind)}
            disabled={val?.form?.disabled}
          />
        </div>
        <div className="pl-3">
          <PlusButton onClick={handleOpenComponent} />
        </div>
        <Modal
          open={open}
          onCancel={() => setOpen(false)}
          footer={null}
          className="select-add-modal"
          getContainer={document.body}
          styles={{
            body: {
              padding: 0,
              margin: 0,
            },
            content: {
              padding: 0,
            },
          }}
        >
          {DynamicComponent && (
            <div
              className="modal-form-wrapper"
              onClick={(e) => e.stopPropagation()}
              onSubmit={(e) => e.stopPropagation()}
            >
              <DynamicComponent
                isModal={true}
                onClose={() => {
                  setOpen(false);
                  handleSearch("", index, ind);
                }}
              />
            </div>
          )}
        </Modal>
      </div>
      <Error id={val?.form?.name?.concat(index + "" + ind)} />
    </React.Fragment>
  );
});

export default Selectaddcomponent;
